import { render } from "./OverlayFadeTransition.vue?vue&type=template&id=24c3f267&scoped=true"
import script from "./OverlayFadeTransition.vue?vue&type=script&lang=js"
export * from "./OverlayFadeTransition.vue?vue&type=script&lang=js"

import "./OverlayFadeTransition.vue?vue&type=style&index=0&id=24c3f267&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c3f267"]])

export default __exports__